import React, { useState } from 'react';
import { IOrder, Segment } from './types';
import { useMediaQuery } from '@material-ui/core';
import StoreAddress from './StoreAddress';
import TabButtons, { TabItem } from '../TabButtons';
import { prependLocaleToPath, prependLocaleToUrl } from '../../../../utils/localization';
import { toLocalDate } from './helpers';
import ConditionalLinkWrapper from '../ConditionalLinkWrapper';

const OrderCard = ({ order, token }: { order: IOrder; token?: string }) => {
  const [activeTab, setActiveTab] = useState(0);
  const segments = order.segments;
  const sortedSegments = [...segments].sort((a, b) => a.sequence - b.sequence);
  const isMobile = useMediaQuery('(max-width: 991.98px)', { noSsr: true });

  const authParam = token ? `&token=${token}` : '';

  const [activeTabContent, setActiveTabContent] = useState<Segment>(sortedSegments[0]!); // [REVISIT]Can we assume Segments array always has at least one item?
  const trackingUrl = prependLocaleToUrl(activeTabContent?.shipment?.tracking_url || '');
  const hasTrackingLink = Boolean(activeTabContent?.shipment?.tracking_number && trackingUrl);

  const handleTabSwitch = (index: number) => {
    setActiveTab(index);
    setActiveTabContent(sortedSegments?.[index] || sortedSegments[0]!);
  };

  const tabItems: TabItem[] = sortedSegments.map((segment) => ({
    key: `${segment.title}-${segment.sequence}`,
    title: segment.title,
  }));

  return (
    <div className="order-wrapper">
      {isMobile ? (
        <table className="header">
          <tr>
            <td className="body w-50">Order Placed</td>
            <td className="body semibold">
              {order.order_placed_utc ? toLocalDate(order.order_placed_utc) : order.order_placed}
            </td>
          </tr>
          <tr>
            <td className="body pb-sm w-50">Order Number</td>
            <td className="pb-sm">
              <a
                href={prependLocaleToPath(
                  `/account/orders/${order.customer_order_url_token}?order_reference=${order.order_number}`
                )}
                className="body semibold"
              >
                <u>{order.order_number}</u>
              </a>
            </td>
          </tr>
        </table>
      ) : (
        <div className="header">
          <div className="body header-item">
            Order Placed{' '}
            <span className="body header-item-value semibold pl-md">
              {order.order_placed_utc ? toLocalDate(order.order_placed_utc) : order.order_placed}
            </span>
          </div>
          <div className="body header-item">
            Order Number{' '}
            <a
              href={prependLocaleToPath(
                `/account/orders/${order.customer_order_url_token}?order_reference=${order.order_number}${authParam}`
              )}
              className="body header-item-value semibold pl-md"
            >
              <u>{order.order_number}</u>
            </a>
          </div>
        </div>
      )}
      <div className="order-status">
        <>
          {sortedSegments.length > 1 && (
            <TabButtons
              tabs={tabItems}
              activeIndex={activeTab}
              onTabChange={handleTabSwitch}
              buttonSize="xs"
              wrapperClassName="shipment-tabs pb-md"
            />
          )}
          {activeTabContent && (
            <div className={`shipment-tab-content`}>
              <a
                href={prependLocaleToPath(
                  `/account/orders/${order.customer_order_url_token}?order_reference=${order.order_number}${authParam}`
                )}
                className="pb-sm editorial-large status-wrapper"
              >
                {activeTabContent.display_status}
              </a>
              {(activeTabContent.type === 'in_store' || activeTabContent.type === 'pickup') &&
                activeTabContent.store_location && <StoreAddress location={activeTabContent.store_location} />}
              <p className="tracking pb-md body">
                {!activeTabContent.display_status?.toLowerCase().includes('canceled') && hasTrackingLink ? (
                  <a href={trackingUrl} className="body semibold">
                    <u>Track Shipment</u>
                  </a>
                ) : (
                  activeTabContent.status_message
                )}
              </p>
              <div className="order-line-items">
                {activeTabContent.items.map((lineItem) => {
                  const { is_clickable, product_title, image_url, handle } = lineItem;
                  const productUrl = handle ? `${prependLocaleToPath(`/products/${handle}`)}` : null;
                  return (
                    <ConditionalLinkWrapper
                      key={handle}
                      isClickable={is_clickable}
                      productUrl={productUrl}
                      ariaLabel={`View details for ${product_title}`}
                    >
                      <img
                        src={image_url || '/cdn/shop/files/Missing_Image_200x.png?v=8684511414166916069'}
                        className="img-fluid"
                        alt={product_title}
                        width={80}
                      />
                    </ConditionalLinkWrapper>
                  );
                })}
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default OrderCard;
